import getConfig from 'next/config';
import isBrowser from '@utils/isBrowser';
import { IEnv } from './i-env';

const { publicRuntimeConfig } = getConfig();
const {
  ENV,
  APP_ENV,
  LOGIN_URL,
  ADMIN_URL,
  IS_CI,
  CI_APOLLO_URI,
  SERVER_APOLLO_URI,
  WEB_APOLLO_URI,
  E2E,
  HELP_CENTER_URL,
  ANALYTICS_ENABLED,
  ANALYTICS_KEY,
  DOMAIN_NAME,
  TUSD_URL,
  THUMBOR_URL,
  ONE_TRUST_ID,
  ONE_TRUST_USE_TEST_SCRIPT,
  YOTPO_CLIENT_ID,
  LOCAL_TO_DEV_REMOTE,
  DD_CLIENT_TOKEN,
  DESIGN_HUB_URL,
} = publicRuntimeConfig;

// For some reason process.env and next only works with destructing, must be done this way
/* istanbul ignore next */
const env: IEnv = {
  ENV,
  APP_ENV,
  LOGIN_URL,
  ADMIN_URL,
  IS_LOCAL: ENV === 'local',
  E2E: E2E === 'true',
  HELP_CENTER_URL,
  ANALYTICS_ENABLED: ANALYTICS_ENABLED === 'true',
  ANALYTICS_KEY,
  DOMAIN_NAME,
  YOTPO_CLIENT_ID,
  getApolloUrl: () => {
    if (IS_CI === 'true') return CI_APOLLO_URI;
    if (!isBrowser()) return SERVER_APOLLO_URI;
    return WEB_APOLLO_URI;
  },
  TUSD_URL,
  THUMBOR_URL,
  ONE_TRUST_ID,
  ONE_TRUST_USE_TEST_SCRIPT: ONE_TRUST_USE_TEST_SCRIPT !== 'false',
  LOCAL_TO_DEV_REMOTE: LOCAL_TO_DEV_REMOTE === 'true',
  DD_CLIENT_TOKEN: DD_CLIENT_TOKEN!,
  DESIGN_HUB_URL,
};

export default env;
